import React, { useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Input,
  Label
} from "reactstrap";

import {
  getAds,
  addAd,
  updateAd,
  deleteAd
} from "../../services/api/api-service";


const Ads = () => {

  // =========================================================
  // STATE
  // =========================================================

  const [ads, setAds] = useState([]);

  const [title, setTitle] = useState("");

  const [image, setImage] = useState("");

  const [link, setLink] = useState("");

  // null = Add mode
  // value = Edit mode
  const [editingId, setEditingId] = useState(null);


  // =========================================================
  // LOAD ADS
  // =========================================================

  const loadAds = async () => {

    try {

      const data = await getAds();

      setAds(data || []);

    } catch (error) {

      console.log("Error loading ads:", error);

      setAds([]);

    }

  };


  // =========================================================
  // LOAD ADS ON PAGE LOAD
  // =========================================================

  useEffect(() => {

    loadAds();

  }, []);


  // =========================================================
  // RESET FORM
  // =========================================================

  const resetForm = () => {

    setTitle("");

    setImage("");

    setLink("");

    setEditingId(null);

  };


  // =========================================================
  // ADD / UPDATE AD
  // =========================================================

  const handleSaveAd = async () => {

    // Image is required
    if (!image.trim()) {

      alert("Please enter Image URL");

      return;

    }


    // Payload sent to backend
    const payload = {

      title: title.trim(),

      image: image.trim(),

      link: link.trim(),

      status: "active",

      date: new Date()

    };


    try {

      // =====================================================
      // UPDATE EXISTING AD
      // =====================================================

      if (editingId !== null) {

        await updateAd(editingId, payload);

        alert("Ad updated successfully");

      }

      // =====================================================
      // ADD NEW AD
      // =====================================================

      else {

        await addAd(payload);

        alert("Ad added successfully");

      }


      // Reset form
      resetForm();


      // Reload ads
      await loadAds();

    } catch (error) {

      console.log("Save Ad Error:", error);

      if (editingId !== null) {

        alert("Failed to update ad");

      } else {

        alert("Failed to add ad");

      }

    }

  };


  // =========================================================
  // EDIT AD
  // =========================================================

  const handleEdit = (ad) => {

    // Set selected ad ID
    setEditingId(ad.id);


    // Fill form with existing data
    setTitle(ad.title || "");

    setImage(ad.image || "");

    setLink(ad.link || "");


    // Scroll to top so admin can edit easily
    window.scrollTo({

      top: 0,

      behavior: "smooth"

    });

  };


  // =========================================================
  // CANCEL EDIT
  // =========================================================

  const handleCancelEdit = () => {

    resetForm();

  };


  // =========================================================
  // DELETE AD
  // =========================================================

  const handleDelete = async (id) => {

    try {

      await deleteAd(id);

      alert("Ad deleted successfully");

      // Reload ads
      await loadAds();

    } catch (error) {

      console.log("Delete Ad Error:", error);

      alert("Failed to delete ad");

    }

  };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <Container fluid>

      {/* =====================================================
          ADD / EDIT FORM
      ====================================================== */}

      <Row>

        <Col lg="12">

          <Card>

            <CardBody>

              <CardTitle tag="h4">

                {editingId !== null
                  ? "Edit Ad"
                  : "Manage Ads"}

              </CardTitle>


              {/* =================================================
                  AD TITLE
              ================================================== */}

              <div className="mb-3">

                <Label for="adTitle">

                  Ad Title

                </Label>

                <Input

                  id="adTitle"

                  type="text"

                  value={title}

                  onChange={(e) =>
                    setTitle(e.target.value)
                  }

                  placeholder="Enter Ad Title"

                />

              </div>


              {/* =================================================
                  IMAGE URL
              ================================================== */}

              <div className="mb-3">

                <Label for="adImage">

                  Ad Image URL

                </Label>

                <Input

                  id="adImage"

                  type="text"

                  value={image}

                  onChange={(e) =>
                    setImage(e.target.value)
                  }

                  placeholder="Enter Image URL"

                />

              </div>


              {/* =================================================
                  REDIRECT LINK
              ================================================== */}

              <div className="mb-3">

                <Label for="adLink">

                  Redirect Link

                  <span
                    style={{
                      color: "#777",
                      marginLeft: 5
                    }}
                  >
                    (Optional)
                  </span>

                </Label>

                <Input

                  id="adLink"

                  type="text"

                  value={link}

                  onChange={(e) =>
                    setLink(e.target.value)
                  }

                  placeholder="https://example.com"

                />

                <small
                  style={{
                    color: "#777"
                  }}
                >
                  Example: YouTube, website, Play Store, etc.
                </small>

              </div>


              {/* =================================================
                  BUTTONS
              ================================================== */}

              <div className="mt-3">

                <Button

                  color={
                    editingId !== null
                      ? "success"
                      : "primary"
                  }

                  onClick={handleSaveAd}

                >

                  {editingId !== null
                    ? "Update Ad"
                    : "Add Ad"}

                </Button>


                {/* Cancel button only in edit mode */}

                {editingId !== null && (

                  <Button

                    color="secondary"

                    className="ml-2"

                    onClick={handleCancelEdit}

                  >

                    Cancel

                  </Button>

                )}

              </div>

            </CardBody>

          </Card>

        </Col>

      </Row>


      {/* =====================================================
          ADS LIST
      ====================================================== */}

      <Row className="mt-4">

        {ads.length === 0 ? (

          <Col lg="12">

            <Card>

              <CardBody>

                <p className="mb-0">

                  No ads found.

                </p>

              </CardBody>

            </Card>

          </Col>

        ) : (

          ads.map((ad) => (

            <Col
              lg="4"
              md="6"
              sm="12"
              key={ad.id}
              className="mb-4"
            >

              <Card>

                <CardBody>

                  {/* =================================================
                      AD IMAGE
                  ================================================== */}

                  <img

                    src={ad.image}

                    alt={ad.title || "Advertisement"}

                    style={{

                      width: "100%",

                      height: "150px",

                      objectFit: "cover",

                      borderRadius: "6px"

                    }}

                  />


                  {/* =================================================
                      AD TITLE
                  ================================================== */}

                  <h5

                    style={{

                      marginTop: "15px",

                      marginBottom: "8px"

                    }}

                  >

                    {ad.title || "Untitled Ad"}

                  </h5>


                  {/* =================================================
                      REDIRECT LINK
                  ================================================== */}

                  <p

                    style={{

                      wordBreak: "break-all",

                      fontSize: "14px",

                      color: "#555",

                      minHeight: "42px"

                    }}

                  >

                    {ad.link ? (

                      ad.link

                    ) : (

                      <span
                        style={{
                          color: "#999"
                        }}
                      >
                        No redirect link
                      </span>

                    )}

                  </p>


                  {/* =================================================
                      BUTTONS
                  ================================================== */}

                  <div>

                    {/* EDIT */}

                    <Button

                      color="warning"

                      className="mr-2"

                      onClick={() =>
                        handleEdit(ad)
                      }

                    >

                      Edit

                    </Button>


                    {/* DELETE */}

                    <Button

                      color="danger"

                      onClick={() =>
                        handleDelete(ad.id)
                      }

                    >

                      Delete

                    </Button>

                  </div>

                </CardBody>

              </Card>

            </Col>

          ))

        )}

      </Row>

    </Container>

  );

};


export default Ads;